/* eslint-disable max-lines-per-function */
/* eslint-disable functional/prefer-readonly-type */
import { createState, useState } from '@hookstate/core'
import { authFetch } from '~/services/fetch'
import type { IWordCloudOccurrence } from '../components/SearchWordCloudModalDraggable/interface'

export interface IResponseWords {
  readonly word: string
  readonly weight: number
}

const occurrencesWordDefault: IWordCloudOccurrence[] = [
  {
    id: null,
    location: null,
    address_reference: null,
    name: null,
    phone: null,
    address: null,
    latitude: null,
    longitude: null,
    emergency: null,
    entry_at: null,
    created_at: null,
    featured: false,
    type: null,
    city: null,
    subtype: null,
    district: null,
    entry_origin: null,
    dispatches: null,
  },
]

const wordCloudState = createState({
  word: '',
  occurrencesWord: occurrencesWordDefault,
  totalOccurrences: 0,
  totalOccurrencesLastHour: 0,
})

export default function useWordCloudState() {
  const wordCloud = useState(wordCloudState.word)
  const occurrencesWord = useState(wordCloudState.occurrencesWord)
  const totalOccurrences = useState(wordCloudState.totalOccurrences)
  const totalOccurrencesLastHour = useState(
    wordCloudState.totalOccurrencesLastHour
  )

  return {
    wordCloud: () => wordCloud,
    occurrencesWord: () => occurrencesWord,
    totalOccurrences: () => totalOccurrences,
    totalOccurrencesLastHour: () => totalOccurrencesLastHour,
    getWords: async (): Promise<IResponseWords[]> => {
      const { data } = await authFetch({
        url: '/word-cloud',
        method: 'POST',
      })

      return data as IResponseWords[]
    },
    getOccurrenceWord: async ({ word }) => {
      try {
        if (!word) {
          occurrencesWord.set([])
          totalOccurrences.set(0)
          totalOccurrencesLastHour.set(0)

          return {
            data: [],
            total_occurrences: 0,
            total_occurrences_last_hour: 0,
          }
        }

        const { data } = await authFetch({
          method: 'POST',
          url: '/occurrences-details-by-comment-word',
          data: {
            word: word,
          },
        })
        const normalizedOccurrences = Array.isArray(data?.data) ? data.data : []
        const normalizedTotalOccurrences = Number(data?.total_occurrences ?? 0)
        const normalizedTotalOccurrencesLastHour = Number(
          data?.total_occurrences_last_hour ?? 0
        )

        occurrencesWord.set(
          normalizedOccurrences as unknown as IWordCloudOccurrence[]
        )
        totalOccurrences.set(normalizedTotalOccurrences)
        totalOccurrencesLastHour.set(normalizedTotalOccurrencesLastHour)

        return data
      } catch (error) {
        occurrencesWord.set([])
        totalOccurrences.set(0)
        totalOccurrencesLastHour.set(0)
        throw error
      }
    },
  }
}
